import { CIRCLE_RADIUS_PORTION } from '../consts';
import { colors } from '@ardoq/design-tokens';
import { Rectangle } from '@ardoq/graph';
type WheelProperties = { viewBounds: Rectangle };

export const Wheel = ({
  viewBounds: [, , viewWidth, viewHeight],
}: WheelProperties) => {
  const minDimension = Math.min(viewWidth, viewHeight);
  const circleRadius = minDimension * CIRCLE_RADIUS_PORTION;
  return (
    <circle
      cx={viewWidth / 2}
      cy={viewHeight / 2}
      r={circleRadius}
      strokeWidth="1"
      stroke={colors.grey400}
      fill={colors.grey200}
    />
  );
};
